import { KycProcessStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isProcessStatusPendingLiveness(kycInfo?: KycResponse | null): boolean {
  return kycInfo?.activeProcess?.processStatus === KycProcessStatus.pending_liveness;
}
